<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Parcelas' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content no-padding>
  <div class="gradient-extendido"></div>
  <ion-card *ngFor="let parcela of parcelas; let i = index;">
    <ion-list class="remove-border">
      <ion-grid>
        <ion-row>
          <ion-col size="5" offset="1">
            <p class="bold-1">{{'Parcela' | translate}}</p>

            <p>
              {{parcela.num}}
              <span *ngIf="plano.parcelasFaltantes != 'recorrente' && parcela.de > 1">
                / {{parcela.de}}</span
              >
            </p>
          </ion-col>

          <ion-col size="5" offset="1">
            <p class="bold-1">{{'Vencimento' | translate}}</p>

            <p>{{parcela.dataVencimento | dateFormat:'ddmmyyyy'}}</p>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col size="5" offset="1">
            <p class="bold-1">{{'Valor' | translate}}</p>

            <p>{{parcela.valor | money | async}}</p>
          </ion-col>

          <ion-col size="5" offset="1">
            <p class="bold-1">{{'Status' | translate}}</p>

            <p
              *ngIf="parcela.removido != '1' && parcela.pago != '1' && !isAtrasado(parcela.dataVencimento)"
              class="orange"
            >
              {{'Em Aberto' | translate}}
            </p>

            <p
              *ngIf="parcela.removido != '1' && parcela.pago != '1' && isAtrasado(parcela.dataVencimento)"
              class="red"
            >
              {{'Atrasado' | translate}}
            </p>

            <p *ngIf="parcela.removido == '1'" class="red">
              {{'Cancelado' | translate}}
            </p>

            <p *ngIf="parcela.pago == '1'" class="green">
              {{'Pago' | translate}}
            </p>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col size="11" offset="1" >
            <p class="bold-1">{{'Forma de Pagamento' | translate}}</p>

            <p>
              {{plano.formaPagamento == 'boleto' ? ('Boleto' | translate) :
              ('Cartão' | translate) }}
            </p>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-list>

    <div
      *ngIf="parcela.pago != '1' && parcela.removido == '0' && plano.formaPagamento == 'boleto' ||
        parcela.pago != '1' && parcela.removido == '0' && plano.formaPagamento == 'pix'
      " 
      class="down"
    >
      <ion-button
        class="btn-default"
        (click)="abrirBoleto(parcela.id)"
        type="button"
      >
        {{'Visualizar Fatura' | translate}}
      </ion-button>
    </div>
  </ion-card>
</ion-content>
